import React from "react";
import Cookies from "js-cookie";
import Logo from "../images/premier-energies.png";
const HomeDisclaimer = ({ onClose }) => {
    const handleCloseClick = () => {
        Cookies.set("loaderHidden", true);
        if (onClose) onClose();
    };

    return (
        <div className="disclaimer-popup">
            <div className="popup-inner">
                <div className="disclaimer-content show-1">
                    {/* Red alert heading with Font Awesome icon */}

                  <img src={Logo} alt="Premier Energies" style={{ height: "40px", float: "left", display: "block", marginLeft: "0" }} />
                    <h2
                        className="section-title text-center"

                    >
                        <i className="fa fa-exclamation-triangle text-warnning mr-3" style={{

                            fontWeight: "bold",
                            color: "red",
                            alignItems: "center",

                        }} aria-hidden="true"></i> &nbsp;
                        IMPORTANT NOTICE
                        &nbsp;
                        <i className="fa fa-exclamation-triangle text-warnning mr-3" style={{

                            fontWeight: "bold",
                            color: "red",
                            alignItems: "center",

                        }} aria-hidden="true"></i>
                    </h2>

                    <div className="disclaimer-text">
                        <div className="disclaimer-text-main">
                            <div className="disclaimer-text-1">
                                <div className="disclaimer-text-inner">
                                    <p>
                                        It has come to our attention that certain unscrupulous
                                        persons/entities are using our company’s logo, name, brand,
                                        PAN and GST number, without our authorisation to sell their
                                        products or offer their different services and collect
                                        advance payments for the purported sale and supply of
                                        products. Such acts are illegal and constitute infringement
                                        of our intellectual property rights, which are punishable
                                        under applicable laws.
                                    </p>
                                    <p>
                                        We have no connection whatsoever with such persons/entities.
                                        We shall not be responsible for any products/services not
                                        directly sold/authorised by us. We shall not be liable for
                                        any loss, damage or injury caused by such unauthorised acts
                                        of third parties.
                                    </p>
                                    <p>
                                        Members of the public are cautioned not to make any payment
                                        to such unauthorised persons/entities and are advised to
                                        avail services only through our authorised channels, after
                                        due enquiry. For any clarifications/confirmation, please
                                        contact us at our registered email address.
                                    </p>
                                    <p>
                                        We reserve our rights to take appropriate legal action,
                                        including civil and criminal proceedings, against those
                                        involved in such unlawful activities.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Bottom close button */}
                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                            <button
                                className="btn btn-primary"
                                style={{ width: "60px" }}
                                onClick={handleCloseClick}
                            >
                                Ok
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeDisclaimer;
